import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoSexo } from "core/resources/types/pessoa";

const { Option } = Select;

export interface SelectSexoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectSexo({ value, ...rest }: SelectSexoProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option value={TipoSexo.Masculino} key={TipoSexo.Masculino}>
        Masculino
      </Option>
      <Option value={TipoSexo.Feminino} key={TipoSexo.Feminino}>
        Feminino
      </Option>
      <Option value={TipoSexo.Outro} key={TipoSexo.Outro}>
        Outro
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectSexo;
